type IconProps = {
  size?: string | number;
  color?: string;
  className?: string;
};

export const ParkingIcon = ({ size = 18, color = 'currentColor', className }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <rect x="3" y="3" width="18" height="18" rx="3" />
    <path d="M9 17V7h4a3.5 3.5 0 0 1 0 7H9" />
  </svg>
);
